export const DEVICE_LIST_REQUEST = "DEVICE_LIST_REQUEST";
export const DEVICE_LIST_SUCCESS = "DEVICE_LIST_SUCCESS";
export const DEVICE_LIST_FAIL = "DEVICE_LIST_FAIL";

export const DEVICE_LIVE_READING_REQUEST = "DEVICE_LIVE_READING_REQUEST";
export const DEVICE_LIVE_READING_SUCCESS = "DEVICE_LIVE_READING_SUCCESS";
export const DEVICE_LIVE_READING_FAIL = "DEVICE_LIVE_READING_FAIL";

export const DEVICE_READINGS_REQUEST = "DEVICE_READINGS_REQUEST";
export const DEVICE_READINGS_SUCCESS = "DEVICE_READINGS_SUCCESS";
export const DEVICE_READINGS_FAIL = "DEVICE_READINGS_FAIL";

export const DEVICE_HISTORY_REQUEST = "DEVICE_HISTORY_REQUEST";
export const DEVICE_HISTORY_SUCCESS = "DEVICE_HISTORY_SUCCESS";
export const DEVICE_HISTORY_FAIL = "DEVICE_HISTORY_FAIL";